import React from 'react'

import { CHECK_FILLED } from '../../../assets/images'
import { ReactListProps } from '../types'
import './ReactStandardList.scss'

const ReactStandardList = (props: ReactListProps): JSX.Element => {
  const { id, icon = CHECK_FILLED, fixedListItems = [], altIcon } = props

  return (
    <div data-testid={`react-standard-list-container`} className={`react-standard-list-container`}>
      {fixedListItems?.length > 0 && (
        <div className='standard-list-details'>
          {fixedListItems?.map((listItem, index) => {
            const { title = '', link = '', openinnewtab, anchor } = listItem
            const newUrl = anchor ? link + `#${anchor}` : link

            return (
              <div className='standard-list-item' key={`standard-list-item-${index}}`} id={id}>
                {icon && (
                  <div data-testid='list-icon-wrapper' className='standard-list-icon'>
                    <img src={icon} alt={altIcon} />
                  </div>
                )}
                <div className='standard-list-point' data-testid={`react-list-item-desc`}>
                  {link ? (
                    <a onClick={() => window.open(newUrl, openinnewtab)}>
                      <span>{title}</span>
                    </a>
                  ) : (
                    <span>{title}</span>
                  )}

                  {/* {linkItems ? getAnchorTemplate(link.url, title, lastModified) : <span>{title}</span>}
                  {!linkItems && showModificationDate && lastModified && <span>{getFormattedDate(lastModified)}</span>}
                  <span>{showDescription && description && { description }}</span> */}
                </div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default ReactStandardList
